import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Container = styled.div`
  height: ${({ $height }) => `${$height}`};
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    height: ${({ $mobileHeight, $height }) =>
      $mobileHeight ? `${$mobileHeight}px` : `${$height}`};
  }
`;

const Spacer = ({ className, height, mobileHeight }) => {
  return (
    <Container
      className={className}
      $height={height}
      $mobileHeight={mobileHeight}
    />
  );
};

Spacer.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  mobileHeight: PropTypes.number,
};

Spacer.defaultProps = {
  className: "",
  height: "100px",
};

export default Spacer;
